module.exports = __webpack_public_path__ + "static/media/splash.39f69520.png";